/* import __COLOCATED_TEMPLATE__ from './deleted-preview-component.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();